import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution } from "../lib/attribution";

/**
 * Mounted once at the app root. Snapshots UTM / gclid / gbraid / wbraid /
 * landing_url / referrer_url into sessionStorage on every route change so any
 * form submission during the visit can attach them.
 */
export default function AttributionListener() {
  const location = useLocation();
  useEffect(() => { captureAttribution(); }, [location.pathname, location.search]);
  return null;
}
